import { useEffect, useState } from 'react';

interface ReorderableItem {
  sortOrder: number;
}

const useReorder = <T extends ReorderableItem>(
  initialItems: T[],
  onReorder: (newItems: T[], from: number, to: number) => void,
  sendWithFromAndToValues: boolean
) => {
  const [items, setItems] = useState(initialItems);

  const moveItem = (from: number, to: number) => {
    const updatedItems = items.map((item) => ({ ...item }));

    const toIndex = updatedItems.findIndex((item) => item.sortOrder === to);
    const fromIndex = updatedItems.findIndex((item) => item.sortOrder === from);

    updatedItems[toIndex].sortOrder = from;
    updatedItems[fromIndex].sortOrder = to;

    const [movedItem] = updatedItems.splice(fromIndex, 1);
    updatedItems.splice(toIndex, 0, movedItem);

    setItems(updatedItems);

    if (sendWithFromAndToValues) {
      onReorder(updatedItems, from, to);
    } else {
      onReorder(updatedItems, -1, -1);
    }
  };

  useEffect(() => {
    setItems(initialItems);
  }, [initialItems]);

  return [items, moveItem] as const;
};

export default useReorder;
